import { useEffect } from "react";

const { VITE_BROWSER_TITLE } = import.meta.env;

export const useDocumentTitle = (pageTitle = "") => {
  useEffect(() => {
    if (pageTitle) {
      document.title = `${pageTitle} · ${VITE_BROWSER_TITLE ?? "Manifold"}`;
    }
  }, [pageTitle]);
};
